import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "../common/Modal";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Blogs = () => {
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);
  const [showproductview, setshowproductview] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [showloding, setshowloding] = useState(false);
  
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([]);

  const defaultColDef = {
    flex: 1,
  };


  const clickhandle = () =>  {
    // console.log('Mission Launched')
  }

  const deletecourse = async (id) => {
    console.log('id >>', id);
    const result = window.confirm("Are you sure you want delete this blog");
    if (result) {
      var data = JSON.stringify({
        id: id,
      });
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "deleteblog", data, headers)
        .then((res) => {
          if (res.data.status == "success") {
            handlefetchdata();
          } else {
          }
        })
        .catch((err) => {
          alert(err.message);
        });
    } else {
      // User clicked Cancel or closed the dialog
      // console.log("User clicked Cancel");
    }
  };

  const handlefetchdata = async() => {
    setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallblogs", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'categoryid', 'tagid', 'productid', 'status', 'type', 'cartvalue', 'discountvalue', 'startdate', 'enddate', 'starttime', 'endtime', 'description', 'status', 'sdesc', 'desc'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    if(columns[i] == 'productName') {
                      obj.minWidth = 400;
                    }
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }
               

                

                //created_at
              //   if(columns.includes('created_at')) {
              //     var craetddatobj = 
              // {
              //   field: "Date",
              //   headerName: "Date",
              //   cellRenderer: (props) => {
              //     // console.log('date props >>', props);
              //     return (
              //            <div>
              //             <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
              //           </div>
              //     )
              //   },
              //   cellRendererParams: {
              //     onClick: clickhandle,
              //   },
              // }
              // columnsarr.push(craetddatobj);
              //   }

              //  status
         var statusobj = 
      {
        field: "status",
        headerName: "Status",
        cellRenderer: (props) => {
        console.log('props >>', props?.data)
          return (
            <div className="orderstatusbg"
            style={props.data.status == 'false' ?
        {backgroundColor: '#FDEDF5'} :
        props.data.status == 'Processing' ?
        {backgroundColor: '#E9EFFD'}
        : {}
        } 
            ><p
            style={props.data.status == 'false' ?
        {color: '#EF3826'} :
        props.data.status == 'Processing' ?
        {color: '#2563EB'}
        : {}
        } 
            >{props.data.status == 'false' ? "In-Active" :
               "Active"}</p></div>
          )
        },
      }
      columnsarr.push(statusobj);
              
                //edit
              var editobj = 
              {
                field: "edit",
                headerName: "Edit",
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            // editlocation(props?.data?.tagid, props?.data?.name);
                            // console.log('props >>', props?.data);
                            navigate('/admin/editblog/'+props?.data?.id)
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="sidebaricons"
                            style={{ color: "blue" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(editobj);

                //delete
      var deleteobj = 
      {
        field: "delete",
        headerName: "Delete",
        cellRenderer: (props) => {
          
          return (
            <div
                  onClick={() => {
                    deletecourse(props?.data?.id);
                    // console.log('props >>', props?.data);
                  }}
                  style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                >
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="sidebaricons"
                    style={{ color: "red" }}
                  />
                </div>
          )
        },
        cellRendererParams: {
          onClick: clickhandle,
        },
      }
      columnsarr.push(deleteobj);
              
               
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);

      //status
      //    var statusobj = 
      // {
      //   field: "status",
      //   headerName: "Status",
      //   cellRenderer: (props) => {
      //   console.log('props >>', props?.data)
      //     return (
      //       <div className="orderstatusbg"
      //       style={props.data.status == 'In-Active' ?
      //   {backgroundColor: '#FDEDF5'} :
      //   props.data.status == 'Processing' ?
      //   {backgroundColor: '#E9EFFD'}
      //   : {}
      //   } 
      //       ><p
      //       style={props.data.status == 'In-Active' ?
      //   {color: '#EF3826'} :
      //   props.data.status == 'Processing' ?
      //   {color: '#2563EB'}
      //   : {}
      //   } 
      //       >{props.data.status}</p></div>
      //     )
      //   },
      // }
      // columnsarr.push(statusobj);

      //edit
    //   var editobj = 
    //   {
    //     field: "edit",
    //     headerName: "Edit",
    //     cellRenderer: (props) => {
          
    //       return (
    //         <div
    //               onClick={() => {
    //                 editlocation(props?.data);
    //                 // console.log('props >>', props?.data);
    //               }}
    //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
    //             >
    //               <FontAwesomeIcon
    //                 icon={faPenToSquare}
    //                 className="sidebaricons"
    //                 style={{ color: "blue" }}
    //               />
    //             </div>
    //       )
    //     },
    //     cellRendererParams: {
    //       onClick: clickhandle,
    //     },
    //   }
    //   columnsarr.push(editobj);


      //delete
    //   var deleteobj = 
    //   {
    //     field: "delete",
    //     headerName: "Delete",
    //     cellRenderer: (props) => {
          
    //       return (
    //         <div
    //               onClick={() => {
    //                 deletecourse(props?.data?.id);
    //                 // console.log('props >>', props?.data);
    //               }}
    //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
    //             >
    //               <FontAwesomeIcon
    //                 icon={faTrash}
    //                 className="sidebaricons"
    //                 style={{ color: "red" }}
    //               />
    //             </div>
    //       )
    //     },
    //     cellRendererParams: {
    //       onClick: clickhandle,
    //     },
    //   }
    //   columnsarr.push(deleteobj);
  }

const navigate = useNavigate();

const newproductclick = () => {
    navigate('/admin/add-new-blog')
  }

  useEffect(() => {
    handlefetchdata()
  }, [])

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="productstogglebar mt-2">
            
            <div className="filterdiv couponfilterdiv" onClick={newproductclick}>
                <FontAwesomeIcon icon={faPlus} className="iconstyles" style={{color: '#64748B'}} />
                <p>New Blog</p>
            </div>
          </div>
          <div
            className={"ag-theme-quartz mt-4"}
            style={{ width: "100%", height: 550 }}
          >
            <AgGridReact
              // modules={AllModules}
              rowData={rowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              rowSelection={"multiple"}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={paginationPageSizeSelector}
              rowHeight={50}
              // onGridReady={onGridReady}
            />
          </div>
        </div>
      </div>
    );
}

export default Blogs;